export default {"src":"/_next/static/media/logo-footer.eb2adf4f.svg","height":24,"width":114,"blurWidth":0,"blurHeight":0};